export default "__VITE_ASSET__9d68422e__"